import * as React from "react";
const DividerSizeSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 7h-1V5h-2V4h2a1 1 0 0 1 1 1v2Zm-9 7v1H4a1 1 0 0 1-1-1v-2h1v2h2ZM3 7h1V5h2V4H4a1 1 0 0 0-1 1v2Zm12 7a1 1 0 0 1-1 1h-2v-1h2v-2h1v2ZM5 9h8v1H5V9Z" }));
DividerSizeSmall.displayName = "DividerSizeSmall";
var DividerSizeSmall_default = DividerSizeSmall;
export {
  DividerSizeSmall_default as default
};
